// extracted by mini-css-extract-plugin
export default {"container":"faq_container__eNfsZ","title":"faq_title__7VAhw","box":"faq_box__+39BP","question":"faq_question__u55pH","answer":"faq_answer__Qavjk","aligned":"faq_aligned__BKlnc"};